<template>
  <div>
    <el-popover placement="bottom-start" width="500" popper-class="pop-ht-city" ref="popCity" @show="showPopverCity"
      @hide="hidePopverCity" v-model="cityVisible" :close-delay="0" trigger="click">
      <div v-if="!searchCityBool">
        <el-tabs type="border-card">
          <el-tab-pane v-for="(item, index) in htCityList" :key="index" :label="item.titleName">
            <div v-if="item.content.length > 0">
              <div class="city-ht">
                <div class="city-ht-item" v-for="(v, i) in item.content" :key="i" @click="checkBtn(v)">
                  <div class="city-top">
                    <span class="city-top-title">{{ v.cityName }}</span>
                    <span class="city-top-detail">{{ v.countryName }}</span>
                  </div>
                  <div class="city-top">
                    <span class="city-top-detail">{{ v.cityNameEn }},</span>
                    <span class="city-top-detail">{{ v.countryNameEn }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>暂无数据</div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div v-else>
        <div>可输入中文/英文/城市名称</div>
        <div class="search-ht-city-result-content" v-if="searchCityListResultCurrent.length > 0">
          <p v-for="(item, index) in searchCityListResultCurrent" :key="index" :class="[
            'search-ht-city-result',
            index == 0 ? 'red' : '',
          ]" @click="checkBtnSearch(item)">
            <span>{{ item.cityName }}</span>
            <span>&nbsp;&nbsp;{{ item.cityNameEn }}</span>
            <span>&nbsp;&nbsp;({{ item.countryName }})</span>
          </p>
        </div>
        <div class="search-ht-city-result-content" v-else>暂无数据</div>
      </div>
      <el-input size="large" prefix-icon="iconfont yj-icon-jiudian1" :style="{ width: inputWidth + 'px' }"
        placeholder="请输入城市" v-model.lazy="ccsqdCityName" @input.native="inputCityEvent" :disabled="disabled"
        slot="reference">
      </el-input>
    </el-popover>
  </div>
</template>

<script>

import { throttle } from '@/plugins/utils';
import { mapMutations, mapState } from 'vuex';
import common from '../../plugins/common';
import HistoryRecord from '../../utils/history';

export default {
  name: 'HtCity',
  props: {
    disabled: {
      type: Boolean,
      default: true,
    },
    inputWidth: {
      type: Number,
      default: 200,
    },
    isModalCity: {
      type: Boolean,
      default: true,
    },
    changeRouteRole: {
      type: [String, Number],
      default: () => {
        return '0'
      }
    },
  },
  data() {
    return {
      currentPageCity: 1,
      isShow: true,
      activeIndex: -1,
      activeIndexSub: -1,
      cityVisible: false,
      CityGeoVisible: false,
      visible: false,
      inputCity: '',
      // keywords: '',
      geoLocationList: [],
      htCityList: [
        {
          title: 'HOT',
          titleName: '历史记录',
          content: [],
        }
      ],
      searchCityListResult: [], // 查询后的城市数据
      searchCityListResultCurrent: [], // 查询后的城市数据分页
      searchCityBool: false,
      searchCityGeoBool: false,
      timeStampCity: 0,
      timeStampCityGeo: 0,
      searchCityGeoListResult: [], // 查询后的商圈数据
      cityChangeNum: 0,
      historyRecord: null,
    }
  },
  computed: {
    //  优化，拿到cityId直接回显操作
    ...mapState({
      htCnQuery: (state) => state.intHt.htCnQuery, //
      htCnCcsqD: (state) => state.intHt.htCnCcsqD, //
      htCnParams: (state) => state.intHt.htCnParams, //
      htCnPolicy: (state) => state.intHt.htCnPolicy, //
    }),
    tripType() {
      /* 默认当前因公因私*/
      return this.htCnQuery.tripType
    },
    cityId: {
      get() {
        return this.htCnParams.cityId
      },
      set(val) {
        this.SET_HTCN_PARAMS({ cityId: val })
      },
    },
    keywords: {
      get() {

        return this.htCnParams.keywords
      },
      set(val) {
        this.SET_HTCN_PARAMS({ keywords: val })
      },
    },
    bookStyle() {
      // 1单订模式  2出差申请单模式
      let bookStyle = this.$common.getBookStyle(this.$store, 10903);
      return bookStyle
    },
    // changeRouteRole() {
    // 	return this.htCnQuery.changeRouteRole
    // },
    ccsqdCityName: {
      get() {
        return this.htCnParams.ccsqdCityName
      },
      set(val) {
        this.SET_HTCN_PARAMS({ ccsqdCityName: val })
      },
    },
  },
  mounted() {
    this.historyRecord = new HistoryRecord(15, 'INT_HT_HISTORY_KEY', true, (a, b) => {
      return a.cityId === b.cityId;
    });
    this.getCity()
  },
  watch: {
    cityId: {
      handler(value, oldvalue) {
        this.cityChangeNum += 1;
        if (value != oldvalue && this.cityChangeNum >= 2) {
          this.keywords = ''
        }
      },
      immediate: true,
      deep: true
    },
    keywords(val) { //关键字为空的时候清空商圈关键字搜索结果,同时需要清空搜索参数
      if (!val) {
        this.isShow = true
        this.searchCityGeoListResult = []
        this.searchCityGeoBool = true
        this.SET_HTCN_PARAMS({
          searchType: 0,
          businessZone: '',
          district: '',
          keywords: '',
          lat: '',
          lon: '',
        })

      } else {
        this.isShow = false
      }
    },
  },
  methods: {
    ...mapMutations({
      SET_HTCN_PARAMS: 'intHt/SET_HTCN_PARAMS'
    }),
    handleCurrentChange(val) {
      this.searchCityListResultCurrent = []
      this.searchCityListResult.map((v, i) => {
        if (i < val * 10 && i >= (val - 1) * 10) {
          this.searchCityListResultCurrent.push(v)
        }
      })
    },
    // 商圈关键字查询
    inputCityGeoEvent: common.debounce2(function (e) {
      let term = e.target.value
      this.$refs.popCityGeo.doShow()
      this.$conn
        .getConn('staticData.interHtKeyWordSearch')({
          cityId: this.cityId,
          count: 50,
          keyWords: term,
          pageNum: 1,
        })
        .then((res) => {
          let data = res.data || {};
          let list = data.list || [];
          this.searchCityGeoListResult = list
          this.searchCityGeoBool = true
        })

    }, 300),
    // 城市关键字查询
    inputCityEvent: common.debounce2(function (e) {
      if (this.disabled) {
        return
      }
      let term = e.target.value
      if (!term) {
        // 清空城市
        this.cityId = '';
      }
      this.timeStampCity = e.timeStamp
      this.$conn
        .getConn('staticData.interCity')({
          count: 10,
          pageNum: 1,
          keywords: term,
        })
        .then((res) => {
          this.$refs.popCity.doShow()
          this.searchCityBool = true
          let data = res.data || {};
          let list = data.list || [];
          this.searchCityListResultCurrent = list;
        })
    }, 300),
    // 内容移入事件
    enter(i, iSub) {
      this.activeIndex = i
      this.activeIndexSub = iSub
    },
    // 内容移出事件
    leave(i) {
      this.activeIndex = -1
      this.activeIndexSub = -1
    },
    // 获取城市数据
    getCity() {
      let list = this.historyRecord.getAll() || [];
      this.$set(this.htCityList[0], 'content', list)
    },
    // 获取商圈数据
    getCityGeo: throttle(function () {
      this.$conn.getConn('staticData.geoLocation')({
        cityId: this.cityId,
        type: '1,2',
      }, (res) => {
        let data = res.data || []
        this.geoLocationList = data;

        this.geoLocationList.map((item) => {
          if (item.type == '1') {
            item.typeName = '行政区'
          } else if (item.type == '2') {
            item.typeName = '商圈'
          }
        })

        this.geoLocationList = this.geoLocationList.filter(item => item.type != 2);
      })
    }, 1000),
    // 内容点击事件
    checkBtn(val) {
      this.ccsqdCityName = val.cityName
      this.cityVisible = false
      this.historyRecord.add(val)
      this.getCity();
      this.$emit('checkHtCity', val)
    },
    // 关键字查询点击事件
    checkBtnSearch(val) {
      let obj = {
        cityId: val.cityId,
        cityName: val.cityName,
        province: val.countryName,
      }
      this.historyRecord.add(val)
      this.getCity();
      this.ccsqdCityName = obj.cityName
      this.$emit('checkHtCity', obj)
      this.$refs.popCity.doClose()
    },
    // 监听弹框显示时的方法
    showPopverCity() {
      if (this.isModalCity) {
        this.cityVisible = true;
      } else if (this.isModalCity == false && this.changeRouteRole == 0) {
        this.cityVisible = false
      } else if (this.isModalCity == false && this.changeRouteRole != 1) {
        this.cityVisible = false
        this.$emit("changeRouteRole2")
      }
    },
    // 监听弹框隐藏时的方法
    hidePopverCity() {
      // 处理
      this.searchCityBool = false
    },
    // 监听弹框显示时的方法
    showPopver() {
    },
    // 监听弹框隐藏时的方法
    hidePopver() {
      // 处理
    },
  },
}
</script>

<style scoped lang="scss">
.pop-ht-city {
  .city-ht {
    max-height: 400px;
    overflow-y: auto;

    .city-ht-item {
      display: flex;
      justify-content: center;
      flex-direction: column;
      background-color: #f8f8fa;
      height: 48px;
      border-radius: 4px;
      padding: 0 8px;
      margin-bottom: 8px;
      cursor: pointer;

      .city-top {
        display: flex;
        align-items: item;

        .city-top-title {
          font-size: 14px;
          color: #222;
          margin-right: 6px;
        }

        .city-top-detail {
          font-size: 12px;
          color: #666;
        }
      }



    }



  }

  .search-ht-city-result-content {
    :hover {
      background-color: #eee;
      cursor: pointer;
    }

    padding-top: 10px;
  }

  .scroll-geo {
    height: 400px;
    overflow-y: scroll;
  }

  .search-ht-city-result {
    display: flex;
    justify-content: flex-start;
    padding: 10px;
  }

  .red {
    color: #f00;
  }
}
</style>
